export const PROPERTY_UI_COMPACT_MAX_WIDTH = '(max-width: 768px)';
